// Turks (tr-TR), kioskBoard: zelfde vorm als kioskBoard.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm). Voor kinderen: korte, eenvoudige woorden.
export const kioskBoardTr = {
    weekToggle: 'Hafta',
    weekTitle: '{week}. hafta',
    weekTitleToday: 'Bugün - {week}. hafta',
    backToToday: 'Bugün',
    menu: 'Daha fazla',
    menuMake: 'Oluştur',
    menuHome: 'Ev',
    menuBoard: 'Pano',
    boardRefreshing: 'Yenileniyor…',
    boardLoading: 'Yükleniyor…',
    boardRefreshFailed: 'Yenilenemedi: bağlantı yok. Pano son bilinen verileri gösteriyor.',
    pageOf: 'Sayfa {n} / {total}',
    prevWeek: 'Önceki hafta',
    nextWeek: 'Sonraki hafta',
    weekEmpty: 'Bu hafta henüz boş',
    // Agendapagina van het bord (oprichter 1 okt 2026): Dag/Week, filter op personen.
    modeDay: 'Gün',
    modeWeek: 'Hafta',
    agendaMode: 'Görünüm',
    prevDay: 'Önceki gün',
    nextDay: 'Sonraki gün',
    filterPeople: 'Kimin için göster',
    noEventsWeek: 'Bu hafta etkinlik yok',
    noEventsDay: 'Bu gün etkinlik yok',
    noEventsFor: '{names} için plan yok',
    // Maandweergave van de agendapagina (oprichter 1 okt 2026).
    modeMonth: 'Ay',
    prevMonth: 'Önceki ay',
    nextMonth: 'Sonraki ay',
    noEventsMonth: 'Bu ay etkinlik yok',
    // Reistijd-knop op de agendapagina (oprichter 1 okt 2026): ritten tonen of verbergen.
    travelToggle: 'Yol süresi',
    rideBring: 'Bırakma',
    rideFetch: 'Alma',
    rideOnTheWay: 'Yolda',
    rideBack: 'Dönüş',
    moreItems: '+{count}',
    laterAt: 'Sonra · {time}',
    nowUntil: 'Şimdi · bitiş {time}',
    scrollMore: 'Diğer etkinlikler',
    tasksMore: 'Diğer görevler',
    tasksLess: 'Yukarı dön',
    departClose: 'Uyarıyı kapat',
    departWho: '{names}: çıkış saati {time} · {title}',
    // Rijders op de detailkaart (oprichter 1 okt: alles vertaald).
    rideDropoff: '{name} götürüyor',
    ridePickup: '{name} alıyor',
    and: 've',
    travel: '{minutes} dk yol',
    leaveAt: 'çıkış {time}',
    /** 0056: reistijd terug: thuis rond deze tijd. */
    travelBack: 'evde {time}',
    conflict: 'Başka bir şeyle aynı anda',
    continues: 'Devam ediyor',
    tomorrowFirst: 'Yarın {time}: {title}',
    waitingApproval: 'Anne/babayı bekliyor',
    klaarApproval: 'Annen ya da baban bir bakacak.',
    doneBy: 'İlk yapan: {name}',
    claimedBy: '{name} yapıyor',
    tryAgain: 'Bir daha?',
    notSaved: 'Olmadı',
    cloudPending: 'Kaydediliyor…',
    memberRail: 'Aile üyeleri',
    pointsReserved: '{count} ayrıldı',
    rewardsTile: 'Ödüller',
    rewardsOf: 'Ödüller: {name}',
    goal: 'Hedef: {name}',
    goalProgress: '{value}/{max}',
    goalHint: 'Birlikte bir hedef seçin',
    rewardCanGet: 'Alabilirsin!',
    /** Rustig, buiten het thema Kinderen. */
    rewardCanGetCalm: 'Alınabilir',
    rewardMissing: '{count} kaldı',
    rewardWaiting: 'Anne/babayı bekliyor',
    rewardBusy: 'Önce diğeri',
    rewardLimit: 'Yarın yine',
    rewardSoldOut: 'Bitti',
    rewardCancel: 'Vazgeç',
    whoAreYou: 'Sen kimsin?',
    requestQuestion: '{reward} istiyor musun?',
    cancelQuestion: '{reward} olmasın mı?',
    keepIt: 'Hayır, kalsın',
    cancelYes: 'Evet, vazgeçtim',
    notYou: 'Başkası mı?',
    areYou: '{name}, sen misin?',
    yesMe: 'Evet, benim',
    notMe: 'Hayır',
    notYours: 'Bu liste {name} için',
    notYoursBody: 'Bak, işte senin listen.',
    closeRewards: 'Bugün ekranına dön',
    detailClose: 'Kapat',
    detailEdit: 'Düzenle',
    sleepWell: 'İyi uykular',
    tomorrowAt: 'Yarın saat {time}: {title}',
    calmDown: 'Yavaş yavaş…',
    upcoming: 'Yakında',
    tomorrowEmpty: 'Henüz bir plan yok',
    inDays: { one: '{count} gün sonra', other: '{count} gün sonra' },
};
//# sourceMappingURL=kioskBoard.tr.js.map